var _style, _g, _path, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiligoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7106 2368",
    style: {
      enableBackground: "new 0 0 7106 2368"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.8,1029.2v-4C144.8,614.3,459,292,886,292c288,0,473.3,120.9,598.2,292l-294.1,227.6 C1109.6,713,1016.9,646.5,882,646.5c-197.4,0-336.4,169.2-336.4,374.6v4c0,211.5,139,376.7,336.4,376.7 c147,0,233.6-68.5,318.2-171.2l294.1,209.5c-132.9,183.3-312.2,318.2-622.4,318.2C469.1,1758.3,144.8,1450.2,144.8,1029.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2321.9,320.2h390.8v1067.5h682.8v342.4H2321.9V320.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4141.9058,
    y1: 1274.3384,
    x2: 6939.6875,
    y2: 1274.3384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69D382"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6221.3,324.2c-279.2,0-507.4,140.6-628.4,348.7c-115.3-198.2-293-321.9-529.1-368.3 c-28.8-5.6-58.1-8.5-87.1-12.7c-35,0-69.9,0-104.9,0c-26.9,3.6-54.1,6.2-80.8,11.1c-229.7,42.2-407,162.9-530.6,360.3 c-96.9,154.7-134.6,324.2-112.4,506c15.1,123.8,63.9,235.2,129.1,339.9c77,123.8,170.6,235,268.7,342.2 c123.2,134.5,248.5,267.1,372.9,400.5c1.7,1.8,4,3.1,6,4.6c2-1.7,3.4-2.6,4.5-3.7c134-143.1,269.2-285.1,401.5-429.8 c92.1-100.8,179.1-206.3,250.2-323.4c14.7-24.2,28.2-48.6,40.4-73c125.4,181,338.3,299.4,596.1,299.4c418.3,0,722.3-315.6,722.3-701 v-3.9C6939.7,636,6639.6,324.2,6221.3,324.2z M5371.4,1458.6c-107.7,91.3-255.9,166.1-447.4,166.1c-326.2,0-550.6-228.9-550.6-538.6 v-3c0-297.8,231.9-541.6,549.1-541.6c188.5,0,302.2,50.9,411.5,143.6l-145.1,175.1c-80.8-67.3-152.6-106.2-273.8-106.2 c-167.6,0-300.7,148.1-300.7,326.2v3c0,191.5,131.7,332.2,317.2,332.2c83.8,0,158.6-20.9,217-62.8v-149.6h-231.9v-199h454.9V1458.6z  M6627.9,1029c0,232.4-166.5,422.1-406.6,422.1c-240.1,0-410.5-193.6-410.5-426v-3.9c0-232.4,166.5-422.1,406.6-422.1 c240.1,0,410.5,193.6,410.5,426V1029z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2064.2,589.8V320.2h-390.8v268.8C1803.5,589.2,1933.8,589.5,2064.2,589.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.4,846.1v884.1h390.8V590.5C1933.7,675.8,1803.5,760.9,1673.4,846.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3965.4,589.8V320.2h-390.8v268.8C3704.8,589.2,3835,589.5,3965.4,589.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3574.6,845.9v884.3h390.8V590.2C3835,675.5,3704.8,760.7,3574.6,845.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiligoLogo);
export default __webpack_public_path__ + "static/media/ciligo-logo.4a7c6942f3abc4db69bbf4c612336c24.svg";
export { ForwardRef as ReactComponent };